export default __webpack_public_path__ + "static/media/vr-bg.d656b3ab.jpg";